import { useEffect, useState } from "react";
import { CountdownItem } from "./CountdownItem";

function getTimeLeft(targetDate) {
  const difference = new Date(targetDate).getTime() - Date.now();
  const safeTime = Math.max(difference, 0);

  return {
    days: Math.floor(safeTime / (1000 * 60 * 60 * 24)),
    hours: Math.floor((safeTime / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((safeTime / (1000 * 60)) % 60),
    seconds: Math.floor((safeTime / 1000) % 60),
  };
}

export function Countdown({ targetDate }) {
  const [timeLeft, setTimeLeft] = useState(null);

  useEffect(() => {
    setTimeLeft(getTimeLeft(targetDate));

    const timer = window.setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);

    return () => window.clearInterval(timer);
  }, [targetDate]);

  if (!timeLeft) {
    return (
      <div className="grid grid-cols-4 gap-1.5 max-w-full md:max-w-xl sm:gap-2 md:gap-3 lg:gap-4">
        <CountdownItem value={0} label="Days" />
        <CountdownItem value={0} label="Hours" />
        <CountdownItem value={0} label="Mins" />
        <CountdownItem value={0} label="Secs" />
      </div>
    );
  }

  return (
    <div className="grid grid-cols-4 gap-1.5 sm:gap-2 md:gap-3 lg:gap-4 max-w-full md:max-w-xl">
      <CountdownItem value={timeLeft.days} label="Days" />
      <CountdownItem value={timeLeft.hours} label="Hours" />
      <CountdownItem value={timeLeft.minutes} label="Mins" />
      <CountdownItem value={timeLeft.seconds} label="Secs" />
    </div>
  );
}

export default Countdown;
